module.exports = __webpack_public_path__ + "media/images/icon_arrow_triangle-881d7de6225efd273efd4e9a6e102d8e.png";